import { useNativeActions } from "@/utils/useNativeActions";
import Link from "next/link";

interface HybridLinkProps {
  href: string;
  nativeAction: () => void;
  className?: string;
  children: React.ReactNode;
}

export const HybridLink = ({
  href,
  nativeAction,
  className = "",
  children,
}: HybridLinkProps) => {
  const { isCmaApp } = useNativeActions();

  if (isCmaApp) {
    return (
      <button className={className} onClick={nativeAction}>
        {children}
      </button>
    );
  }

  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
};
